export const columnOptions = [
  {
    label: 'Airline',
    selected: true,
    locked: false,
    disabled: false,
    value: 'airline',
  },
  {
    label: 'Origin',
    selected: true,
    locked: false,
    disabled: false,
    value: 'origin',
  },
  {
    label: 'Destination',
    selected: true,
    locked: false,
    disabled: false,
    value: 'destination',
  },
  {
    label: 'Commodity',
    selected: true,
    locked: false,
    disabled: false,
    value: 'commodity',
  },
  {
    label: 'Airline Product',
    selected: true,
    locked: false,
    disabled: false,
    value: 'airlineProdCode',
  },
  {
    label: 'Rate Type',
    selected: true,
    locked: false,
    disabled: true,
    value: 'rateType',
  },
  { label: 'Min', selected: true, locked: false, disabled: false, value: 'M' },
  { label: 'Nom', selected: true, locked: false, disabled: false, value: 'N' },
  {
    label: '45-KG',
    selected: true,
    locked: false,
    disabled: false,
    value: 'kg45',
  },
  {
    label: '100-KG',
    selected: true,
    locked: false,
    disabled: false,
    value: 'kg100',
  },
  {
    label: '300-KG',
    selected: true,
    locked: false,
    disabled: false,
    value: 'kg300',
  },
  {
    label: '500-KG',
    selected: false,
    locked: false,
    disabled: false,
    value: 'kg500',
  },
  {
    label: '1000-KG',
    selected: false,
    locked: false,
    disabled: false,
    value: 'kg1000',
  },
  {
    label: '3000-KG',
    selected: false,
    locked: false,
    disabled: false,
    value: 'kg3000',
  },
  {
    label: 'Start',
    selected: false,
    locked: false,
    disabled: false,
    value: 'startDate',
  },
  {
    label: 'End',
    selected: false,
    locked: false,
    disabled: false,
    value: 'endDate',
  },
  {
    label: 'FSC',
    selected: true,
    locked: false,
    disabled: false,
    value: 'fuelSurcharge',
  },
  {
    label: 'IRC',
    selected: true,
    locked: false,
    disabled: false,
    value: 'securitySurcharge',
  },
  {
    label: 'RFS',
    selected: true,
    locked: false,
    disabled: false,
    value: 'miscellaneousCharge',
  },
  {
    label: 'SAF',
    selected: true,
    locked: false,
    disabled: false,
    value: 'saf',
  },
  {
    label: 'Currency',
    selected: true,
    locked: false,
    disabled: false,
    value: 'currency',
  },
  {
    label: 'SHC',
    selected: false,
    locked: false,
    disabled: false,
    value: 'shcs',
  },
  {
    label: 'Aircraft Types',
    selected: false,
    locked: false,
    disabled: false,
    value: 'aircraftTypes',
  },
  {
    label: 'Density',
    selected: false,
    locked: false,
    disabled: false,
    value: 'density',
  },
  {
    label: 'Day',
    selected: false,
    locked: false,
    disabled: false,
    value: 'day',
  },
  {
    label: 'Flight No.',
    selected: false,
    locked: false,
    disabled: false,
    value: 'flightNo',
  },
  {
    label: 'Last Updated',
    selected: false,
    locked: false,
    disabled: false,
    value: 'lastUpdatedDate',
  },
  {
    label: 'Support',
    selected: true,
    locked: true,
    disabled: true,
    value: 'contacts',
  },
];
